import LegalLayout from './LegalLayout';

const H = ({ children }) => (
  <h2 className="text-xl font-heading text-foreground mt-8 mb-2">{children}</h2>
);

const Terms = () => (
  <LegalLayout
    title="Terms & Conditions"
    description="Terms and conditions for bookings and stays at Rudragarh Resort, Damodra, near Jaisalmer, Rajasthan."
    path="/terms"
    updated="July 2026"
  >
    <p>
      These Terms &amp; Conditions ("Terms") govern your use of the Rudragarh Resort
      website and the booking of any stay, room, or experience with us. By making a
      booking or using this website, you agree to these Terms. Rudragarh Resort is
      located at Village Damodra, Sam Road, near Jaisalmer, Rajasthan 345001, India.
    </p>

    <H>1. Bookings</H>
    <p>
      A booking is a request until confirmed by us in writing (via email or WhatsApp).
      We reserve the right to decline or cancel any booking. You must be at least 18
      years old to make a booking and are responsible for the accuracy of the details
      you provide, including guest names, dates, and contact information.
    </p>

    <H>2. Rates &amp; Taxes</H>
    <p>
      All rates are quoted in Indian Rupees (INR) and are per room, per night, unless
      stated otherwise. Rates are subject to applicable government taxes (GST) and may
      change without notice until a booking is confirmed. The total payable amount shown
      at the time of confirmation is final for that booking.
    </p>

    <H>3. Check-in &amp; Check-out</H>
    <p>
      Check-in is from 11:00 AM and check-out is by 10:00 AM. Early check-in and late
      check-out are subject to availability and may attract additional charges. A valid
      government-issued photo ID is required at check-in for every adult guest, as
      mandated by law.
    </p>

    <H>4. Payments</H>
    <p>
      Bookings may be secured via the payment options offered on our website or by
      arrangement with the resort. Online payments, where available, are processed by our
      third-party payment partner; we do not store your card or banking details. Your
      reservation is confirmed only once we acknowledge it.
    </p>

    <H>5. Cancellations &amp; Refunds</H>
    <p>
      Cancellations, amendments, and refunds are governed by our{' '}
      <a href="/refund-cancellation" className="text-gold-500 underline">Refund &amp; Cancellation Policy</a>,
      which forms part of these Terms.
    </p>

    <H>6. Guest Conduct &amp; House Rules</H>
    <p>
      Guests are expected to conduct themselves respectfully and to comply with resort
      rules and the reasonable instructions of our staff. We may refuse service to, or
      require the departure of, any guest whose conduct is unlawful, unsafe, or disruptive
      to other guests or staff, without refund. Guests are responsible for any loss or
      damage to resort property caused by them or their party.
    </p>

    <H>7. Liability</H>
    <p>
      Many resort activities (including but not limited to swimming, ATV rides, horse
      riding, and dune excursions) carry inherent risks and are undertaken at the guest's
      own risk. To the extent permitted by law, Rudragarh Resort is not liable for
      personal injury, loss, or damage to guests or their belongings save where caused by
      our proven negligence. We are not liable for failure or delay caused by events
      beyond our reasonable control.
    </p>

    <H>8. Changes to These Terms</H>
    <p>
      We may update these Terms from time to time. The version in effect at the time of
      your booking applies to that booking. Continued use of the website constitutes
      acceptance of the current Terms.
    </p>

    <H>9. Governing Law</H>
    <p>
      These Terms are governed by the laws of India, and any disputes are subject to the
      exclusive jurisdiction of the courts at Jaisalmer, Rajasthan.
    </p>

    <H>10. Contact</H>
    <p>
      Rudragarh Resort — Village Damodra, Sam Road, near Jaisalmer, Rajasthan 345001,
      India. Email: <a href="mailto:info@rudragarh.com" className="text-gold-500 underline">info@rudragarh.com</a>,
      Phone: <a href="tel:+919649611111" className="text-gold-500 underline">+91 96496 11111</a>.
    </p>
  </LegalLayout>
);

export default Terms;
